const setSearchValue = searchValue => ({
  type: 'SCHOOL_TEACHERS_FILTER:SET_SEARCH_VALUE',
  searchValue
})

export { setSearchValue }
